// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Alert: {
    close: 'Close'
  },
  Card: {
    select: 'Sélectionner',
    titleLinkTooltip: 'Ouvrir la page',
    collapseCardTooltip: 'Réduire la carte',
    expandCardTooltip: 'Étendre la carte'
  },
  CardList: {
    loadMore: 'Charger plus',
    notFound: 'Aucun élément trouvé.',
    toolbarSelect: 'Sélectionner',
    viewCards: 'Cartes',
    viewTiles: 'Tuiles',
    viewList: 'Liste',
    toolbarView: 'Vue'
  },
  Carousel: {
    nextSlide: 'Next slide',
    previousSlide: 'Previous slide',
    viewSlide: 'View slide %%slideNumber%%'
  },
  ComboBox: {
    close: 'Close',
    open: 'Open'
  },
  ClosingConfirmation: {
    confirm: 'Quitter',
    cancel: 'Revenir',
    content: 'Voulez-vous fermer et quitter cette fenêtre ? Toutes les modifications de vos données seront perdues.'
  },
  Cuttable: {
    showMore: 'Afficher plus',
    showLess: 'Afficher moins'
  },
  Dialog: {
    closeButton: 'Close',
    cancelButton: 'Annuler'
  },
  Drawer: {
    backButton: 'Back',
    closeButton: 'Close',
    hideButton: 'Hide'
  },
  DrawerProgress: {
    cancelButton: 'Annuler'
  },
  Dropdown: {
    close: 'Fermer'
  },
  Form: {
    submitButton: 'Enregistrer',
    applyButton: 'Appliquer',
    cancelButton: 'Annuler'
  },
  FormField: {
    clear: 'Effacer',
    remove: 'Supprimer',
    addMore: 'Ajouter un champ',
    showDescription: 'Show description'
  },
  FormFieldPassword: {
    improvePassword: 'Pour améliorer votre mot de passe :',
    passwordTooShort: 'Ajoutez des caractères.',
    lettersLowerCase: 'Utilisez au moins une minuscule.',
    lettersUpperCase: 'Utilisez au moins une majuscule.',
    numbers1: 'Utilisez au moins un chiffre.',
    numbers3: 'Utilisez au moins trois chiffres.',
    specialChar1: 'Utilisez au moins un caractère spécial (par exemple : !, @, #, $, %, ^, &, *, ?, _, ~).',
    specialChar2: 'Utilisez au moins deux caractères spéciaux (par exemple : !, @, #, $, %, ^, &, *, ?, _, ~).',
    comboUpperAndLower: 'Utilisez des majuscules et des minuscules.',
    comboLettersAndNumbers: 'Utilisez des nombres et des caractères.',
    comboLettersNumbersSpecial: 'Utilisez des nombres, des caractères et des caractères spéciaux.',
    yourPasswordIsStrong: 'Vous pouvez renforcer la sécurité du mot de passe en utilisant plus de caractères.',
    passwordStrength: 'Sécurité du mot de passe :',
    strengthVeryStrong: 'TRÈS ÉLEVÉE',
    strengthStrong: 'ÉLEVÉE',
    strengthVeryWeak: 'TRÈS FAIBLE',
    strengthWeak: 'FAIBLE',
    strengthMedium: 'MOYENNE',
    hidePassword: 'Masquer le mot de passe',
    showPassword: 'Afficher le mot de passe',
    generateButton: 'Générer',
    copyButtonHint: 'Copier le mot de passe',
    copySuccessToast: 'Le mot de passe a été copié.',
    generateButtonHint: 'Générer un mot de passe fort'
  },
  InPlaceEdit: {
    cancelButtonHint: 'Ignorer les modifications',
    editButtonHint: 'Modifier la valeur',
    okButtonHint: 'Enregistrer les modifications'
  },
  InputNumber: {
    decrement: 'Decrement',
    increment: 'Increment'
  },
  InputFile: {
    browseButton: 'Choisir le fichier…'
  },
  Layout: {
    openSidebar: 'Expand sidebar',
    closeSidebar: 'Collapse sidebar'
  },
  List: {
    totalRows: 'Total : %%totalRows%%',
    toggleAllRows: 'Toggle all rows',
    toggleRow: 'Toggle row',
    selectedRows: 'Sélection : %%selectedRows%% sur %%totalRows%%',
    all: 'Tous',
    allItemsOnPageSelected: 'Tous les éléments de la page sont sélectionnés',
    allItemsSelected: 'Tous les éléments sont sélectionnés',
    selectAllItems: 'Sélectionner tous les éléments',
    selectAllItemsOnPage: 'Sélectionner tous les éléments sur la page',
    deselectAll: 'Retirer de la sélection',
    selectRow: 'Select row',
    selectAllRows: 'Select all rows'
  },
  ListActions: {
    menuButton: 'Open menu'
  },
  ListEmptyView: {
    filteredTitle: 'Aucun élément ne correspond au filtre',
    emptyTitle: "Oups, il n'y a rien ici…",
    filteredDescription: 'Ajustez votre demande ou retirez des critères du filtre, puis réessayez.'
  },
  ListOperation: {
    cancelButton: 'Annuler'
  },
  Panel: {
    collapse: 'Collapse',
    expand: 'Expand'
  },
  Pagination: {
    totalShort: 'sur %%total%%',
    itemsPerPage: 'Éléments par page',
    all: 'Tous',
    total: 'Page %%current%% sur %%total%%'
  },
  Popover: {
    closeButton: 'Close'
  },
  ProgressDialog: {
    closeButton: 'Fermer',
    cancelButton: 'Annuler'
  },
  Section: {
    collapse: 'Collapse',
    closeButton: 'Close',
    expand: 'Expand'
  },
  Select: {
    clearButton: 'Clear',
    noOptions: 'Aucune option',
    placeholder: 'Sélectionner…'
  },
  SearchBar: {
    clearButton: 'Clear',
    searchButton: 'Search',
    collapseSearch: 'Hide search input',
    expandSearch: 'Show search input'
  },
  SpotPopup: {
    total: '%%current%% sur %%total%%'
  },
  SwitchesPanelItem: {
    showDescription: 'Show description'
  },
  Tabs: {
    closeButton: 'Close tab'
  },
  Toaster: {
    closeGroup: 'Fermer le groupe'
  },
  Toast: {
    closeButton: 'Close'
  }
};